export default __webpack_public_path__ + "static/media/modelx1.dbfcce81.jfif";